import React from 'react';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Card, CardHeader, CardBody} from 'reactstrap';

const WeldProcessErrors = createClass({
  propTypes: {
    process_errors: PropTypes.string.isRequired,
  },

  renderProcessErrors() {
    let arrE = [];
    for (const [k, v] of Object.entries(JSON.parse(this.props.process_errors))) {
      if (k !== "0") {
        arrE.push(<b key={k}>Repair {k}</b>);
      }
      Object.values(v).map((err, i) => arrE.push(<li key={`${k}_${i}`}>{err.join(', ')}</li>))
    }

    return arrE;
  },

  render() {
    return (
      <Card className="text-white bg-danger">
        <CardHeader>
          <b style={{color: "black"}}>Welding process errors</b>
        </CardHeader>
        <CardBody className="card-body">
          <ul>
            {this.renderProcessErrors()}
          </ul>
        </CardBody>
      </Card>
    );
  }
});

export default WeldProcessErrors



// WEBPACK FOOTER //
// ./src/components/Logs/WeldProcessErrors.js